import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

class ThemeName extends React.Component {
    static propTypes = {
        theme: PropTypes.object,
        logoSrc: PropTypes.string,
        /** The hyperlink to open when the logo is clicked. */
        logoUrl: PropTypes.string,
    }
    state = {
        title: null,
        onlineresource: null
    }
    static defaultProps = {
        logoSrc: "assets/img/logo.svg",
        logoFormat: "svg"
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.title !== this.props.theme.attribution.Title) {
          this.setState({title: this.props.theme.attribution.Title});
        }
        if (prevState.onlineresource !== this.props.theme.attribution.OnlineResource) {
            this.setState({onlineresource: this.props.theme.attribution.OnlineResource});
        }
      }
    render() {
        let logo;
        let logoEl = (<img className="swecologo" src={this.props.logoSrc || logo} />);
        if (this.props.logoUrl) {
            logoEl = (<a href={this.props.logoUrl} rel="noreferrer" target="_blank">{logoEl}</a>);
        }
        return (
            <div className="themename"> 
                {logoEl}
                <div className="name">
                    <a href={this.state.onlineresource} target="_blank">{this.state.title}</a>
                </div>
            </div>
        );
    }
}

const selector = (state) => ({
    theme: state.theme.current
});

export default connect(selector)(ThemeName);